module.exports = __webpack_public_path__ + "static/advanced-analytics-381cecccbce144eff733e1daff655a90.png";